import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMaybeAssignCategoryTreeExperiment } from "@faire/retailer-visitor-shared/lib/useMaybeAssignCategoryTreeExperiment";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { IRecordCategoryNodesVisibilityRequest } from "@faire/web-api--source/indigofair/category/IRecordCategoryNodesVisibilityRequest";
import uniq from "lodash/uniq";
import React, { useEffect } from "react";
import styled from "styled-components";
import { SidebarLink } from "@faire/retailer/components/Filter/filter-components/Components/SidebarLink";
var Source = IRecordCategoryNodesVisibilityRequest.Source;
var recursivelyGetChildCategoryPathIdentifiers = function(links, selectedCategoryPathIdentifier) {
    return links.filter(function(link) {
        var _link_identifier;
        return selectedCategoryPathIdentifier && ((_link_identifier = link.identifier) === null || _link_identifier === void 0 ? void 0 : _link_identifier.startsWith(selectedCategoryPathIdentifier));
    }).flatMap(function(link) {
        var _link_identifier;
        return [
            (_link_identifier = link.identifier) !== null && _link_identifier !== void 0 ? _link_identifier : ""
        ].concat(_to_consumable_array(recursivelyGetChildCategoryPathIdentifiers(link.childNavLinks, selectedCategoryPathIdentifier)));
    });
};
export var LeftNavInner = function(param) {
    var options = param.options, selectedIdentifier = param.selectedIdentifier, optionDataTestId = param.optionDataTestId;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var maybeAssignCategoryTreeExperiment = useMaybeAssignCategoryTreeExperiment();
    useEffect(function() {
        if (options !== undefined) {
            maybeAssignCategoryTreeExperiment(function() {
                return uniq(recursivelyGetChildCategoryPathIdentifiers(options, selectedIdentifier));
            }, Source.WEB_DESKTOP_LEFT_NAV);
        }
    }, [
        options,
        selectedIdentifier,
        maybeAssignCategoryTreeExperiment
    ]);
    return /*#__PURE__*/ _jsx(Container, {
        "data-test-id": "category-page-sidebar",
        "aria-label": strictLocalize({
            id: "NoaLqW",
            defaultMessage: [
                {
                    type: 0,
                    value: "Side Navigation"
                }
            ]
        }),
        children: /*#__PURE__*/ _jsx("ul", {
            children: (options !== null && options !== void 0 ? options : []).map(function(option) {
                return /*#__PURE__*/ _jsx("li", {
                    children: /*#__PURE__*/ _jsx(SidebarLink, {
                        dataTestId: optionDataTestId,
                        option: option,
                        selectedIdentifier: selectedIdentifier
                    })
                }, option.to);
            })
        })
    });
};
var Container = styled.nav.withConfig({
    componentId: "sc-68296cff-0"
})([
    "margin-bottom:8px;"
]);
